if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
  super();

  this.addEventListener('click', (event) => {
  const button = event.target.closest('[data-modal-nav]');
  if (!button) return;

  event.preventDefault();

  const container = this.querySelector('[role="document"]');
const media = [...container.children].filter((item) =>
  item.hasAttribute('data-media-id')
);
const activeIndex = media.findIndex((item) =>
  item.classList.contains('active')
);

  if (activeIndex === -1 || media.length < 2) return;

  const direction = button.dataset.modalNav === 'next' ? 1 : -1;
  const nextIndex = (activeIndex + direction + media.length) % media.length;

  const opener = this.openedBy;
  if (!opener) return;

  opener.setAttribute('data-media-id', media[nextIndex].getAttribute('data-media-id'));
this.showActiveMedia();
});
}

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
